import React, { FC } from 'react'
import styled from 'styled-components'

import { breakpoints } from '@ads/front-core/constants/breakpoints'

export const DotsDesktop: FC = () => (
  <DotsWrapper>
    <svg
      width="327"
      height="38"
      viewBox="0 0 327 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2545 17.0959C104.027 -35.6924 180.325 65.8513 325.163 28.58"
        stroke="#71757D"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="14 14"
      />
    </svg>
    <svg
      width="327"
      height="38"
      viewBox="0 0 327 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2545 17.0959C104.027 -35.6924 180.325 65.8513 325.163 28.58"
        stroke="#71757D"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="14 14"
      />
    </svg>
    <svg
      width="327"
      height="38"
      viewBox="0 0 327 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2545 17.0959C104.027 -35.6924 180.325 65.8513 325.163 28.58"
        stroke="#71757D"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="14 14"
      />
    </svg>
    <svg
      width="327"
      height="38"
      viewBox="0 0 327 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2545 17.0959C104.027 -35.6924 180.325 65.8513 325.163 28.58"
        stroke="#71757D"
        strokeOpacity="0.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="14 14"
      />
    </svg>
  </DotsWrapper>
)

const DotsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 180px;
  left: 16px;

  svg {
    transform: rotate(-2deg);
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;
  }
`
